export const GET_HOME_WORK = 'GET_HOME_WORK'
export const GET_HOME_WORK_BY_ID = 'GET_HOME_WORK_BY_ID'

export const UPDATE_HOME_WORK_BY_ID = 'UPDATE_HOME_WORK_BY_ID'

export const RESET_UPDATE_HOME_WORK_BY_ID = 'RESET_UPDATE_HOME_WORK_BY_ID'
